import React from 'react';
import { Grid } from 'semantic-ui-react';
import BasicSectionLayout from './SectionLayout';

const Footer = () => {
  return (
    <BasicSectionLayout fluide={true} sectionClasse="footer">
      <Grid.Column  width={16}>
        <div className="footer__left"> Copyrights FIPI 2019. All rights reserved. </div>
      </Grid.Column>
    </BasicSectionLayout>
  );
}

export default Footer;